import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import IconWithTooltip from "shared/react_components/IconWithTooltip";
import EmailNotificationsDropdown from "./EmailNotificationsDropdown";

import NotificationCheckbox, { checkboxProps } from "./NotificationCheckbox";

const UserNotificationSettings = ({
  generalPreferences,
  bundledPreferences,
  nameForAdvertiser
}) => {
  return (
    <Card>
      <CardHeader tag="h3">Notification Settings</CardHeader>
      <CardBody>
        <Row>
          <Col md={9}>
            <CardTitle>Emails to Notify</CardTitle>
            <EmailNotificationsDropdown />
          </Col>
        </Row>
        {
          <div>
            <CardTitle>General Preferences</CardTitle>
            {generalPreferences.map(({ name, ...notification }) => (
              <NotificationCheckbox
                key={name}
                name={`notificationSettings.${name}`}
                {...notification}
              />
            ))}
            {!!bundledPreferences.length && (
              <>
                <CardTitle className="flex-centered-vertically">
                   Bundled Preferences
                  <IconWithTooltip className="ml-1 text-info" icon="help">
                     These notifications will come from the bundled{" "}
                    {nameForAdvertiser} account for Network Bundled campaigns as
                     well as relevant notifications regarding the campaigns being
                     bundled.
                  </IconWithTooltip>
                </CardTitle>
                {bundledPreferences.map(({ name, ...notification }) => (
                  <NotificationCheckbox
                    key={name}
                    name={`notificationSettings.${name}`}
                    {...notification}
                  />
                ))}
              </>
            )}
          </div>
        }
      </CardBody>
    </Card>
  );
};

const notificationPreferenceProp = PropTypes.shape(checkboxProps);

UserNotificationSettings.propTypes = {
  generalPreferences: PropTypes.arrayOf(notificationPreferenceProp).isRequired,
  bundledPreferences: PropTypes.arrayOf(notificationPreferenceProp).isRequired,
  nameForAdvertiser: PropTypes.string.isRequired
};

export default UserNotificationSettings;
